import type { ButtonHTMLAttributes, ReactNode } from 'react'

export type VccActionButtonProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children'
> & {
  children?: ReactNode
  label?: string
  loading?: boolean
  loadingLabel?: string
  showIcon?: boolean
  className?: string
}

export function vccButtonLabel(
  props: Pick<VccActionButtonProps, 'children' | 'label' | 'loading' | 'loadingLabel'>,
  defaultLabel: string,
): ReactNode {
  if (props.loading) {
    return props.loadingLabel ?? defaultLabel
  }
  return props.children ?? props.label ?? defaultLabel
}
